<template>
  <div class="tab-other-container">
    <div class="status">
      <div class="status-item" :class="{active: index == status,buy: index == 0,sell: index == 1,}" v-for="(item, index) in statusList" @click="changeStatus(index)" :key="item">{{ $t(item) }}</div>
    </div>
    <div class="coin-type">
      <div class="coin-type-item" :class="{ active: currency_value == item.key }" v-for="item in currency" @click="changeCurrencyType(item.key)" :key="item.id">{{ item.value | upcase }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: 0,
      statusList: ['400129', '400130'],
      currency_value: "",
    };
  },
  computed: {
    currency() {
      return this.$store.getters.getEnum("currency");
    },
  },
  created() {
    this.status = this.$route.query.status ? this.$route.query.status : 0
    this.currency_value = this.$route.query.currency ? this.$route.query.currency : 'usdt'
  },
  methods: {
    changeCurrencyType(key) {
      this.currency_value = key;
      this.search();
    },
    changeStatus(index) {
      this.status = index;
      this.search();
    },
    search() {
      this.$emit("search", {
        currency_value: this.currency_value,
        status: this.status,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.tab-other-container {
  ::v-deep .el-table th.el-table__cell {
    background: transparent !important;
  }
  width: 1200px;
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  .status {
    @include background-color("background-color-hover");
    border-radius: 14px;
    display: flex;
    &-item {
      height: 28px;
      line-height: 28px;
      border-radius: inherit;
      font-size: 14px;
      color: #7f8490;
      cursor: pointer;
      padding: 0 14px;
    }
    &-item.active.buy {
      background-color: #00b464;
      color: #ffffff;
    }
    &-item.active.sell {
      background-color: #fa4d56;
      color: #ffffff;
    }
  }

  .coin-type {
    display: flex;
    height: 28px;
    align-items: center;
    margin: 0 16px;
    padding: 0 4px;
    @include background-color("background-color-hover");
    border-radius: 14px;

    &-item {
      height: 20px;
      line-height: 20px;
      color: #7f8490;
      font-size: 12px;
      cursor: pointer;
      padding: 0 8px;
      &.active {
        background-color: #ffc72b;
        color: #000922;
        border-radius: 10px;
      }
    }
  }
}
</style>
